// Pure helpers shared by the session tabs (Agenda, Action Items).

/**
 * truncateItemText - caps list text at `maxLength`; callers show a tooltip only when cut.
 * Counts code points so an emoji on the cut point isn't split in half.
 */
export const truncateItemText = (text, maxLength) => {
  const full = text ?? "";
  const chars = Array.from(full);
  if (chars.length <= maxLength) return { display: full, isTruncated: false };
  return { display: `${chars.slice(0, maxLength).join("").trimEnd()}...`, isTruncated: true };
};

/**
 * scrollToBottom - scrolls a tab's scroll container to its bottom on the next frame.
 *
 * Both tabs render their add form at the bottom of the list and call this from the input's onFocus
 * (the field auto-focuses when the form opens). The one-frame deferral matters: the browser does
 * its own partial "scroll focused element into view" on autofocus, so scrolling synchronously lets
 * the native scroll land afterwards and leave the form half cut off. Deferring puts us last.
 *
 * Takes the ref rather than the element so callers can pass it before the node exists.
 */
export const scrollToBottom = (scrollRef) => {
  const el = scrollRef?.current;
  if (!el) return;
  requestAnimationFrame(() => el.scrollTo({ top: el.scrollHeight }));
};
